import { createContext, useContext } from 'react'

import type { Api } from '@subaio/utils'

const apiContext = createContext<Api | undefined>(undefined)

/** Since we have components in markdown files that sometimes need their own API access, we need a context provider
 * for the API since we cannot pass this prop down from a markdown file without hassle. */
export const useApi = () => {
	const api = useContext(apiContext)

	if (!api) throw new Error('Cannot useApi without provider')

	return api
}

export const ApiProvider = apiContext.Provider
